import * as React from 'react'
import { css } from 'glamor'

import { useTheme } from '../../../theme'

interface ITableRendererProps {
  children?: React.ReactNode
}

export default function TableRenderer({ children }: ITableRendererProps) {
  const theme = useTheme()

  return (
    <table
      {...css({
        borderSpacing: '0',
        borderCollapse: 'collapse',
        backgroundColor: 'transparent',
        width: '100%',
        maxWidth: '100%',
        marginBottom: theme.settings.spacing.large,
        padding: '5px',
      })}
    >
      {children}
    </table>
  )
}
